(() => {
  if (window.__bikezoneMarqueeBrandsLoaded) return;
  window.__bikezoneMarqueeBrandsLoaded = true;

  const SELECTOR = ".custom-logo-marquee";

  const prefersReducedMotion = () =>
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const initMarquee = (section) => {
    const viewport = section.querySelector("[data-marquee-viewport]");
    const inner = section.querySelector("[data-marquee-inner]");
    const prevBtn = section.querySelector("[data-marquee-prev]");
    const nextBtn = section.querySelector("[data-marquee-next]");

    if (!viewport || !inner) return;

    const getTracks = () => inner.querySelectorAll(".custom-logo-marquee__track");

    const getLoopWidth = () => {
      const tracks = getTracks();
      if (tracks.length) return tracks[0].scrollWidth;
      return 0;
    };

    const dir = (section.dataset.direction || "left").toLowerCase();
    const speedSeconds = Math.max(parseFloat(section.dataset.speed || "12"), 6);

    let rafId = null;
    let visible = false;
    let paused = false;
    let lastTs = 0;
    let pos = 0;
    let loopWidth = 0;
    let resizeRaf = null;

    const run = !prefersReducedMotion();

    const applyPosition = () => {
      inner.style.transform = `translate3d(${-pos}px, 0, 0)`;
    };

    const measure = () => {
      const tracks = getTracks();
      loopWidth = tracks.length ? tracks[0].scrollWidth : 0;

      if (!loopWidth) return;

      if (!pos) pos = loopWidth;
      normalizePos();
    };

    const normalizePos = () => {
      if (!loopWidth) return;

      if (pos >= loopWidth * 2) {
        pos -= loopWidth;
      } else if (pos < loopWidth) {
        pos += loopWidth;
      }

      applyPosition();
    };

    const pxPerSecond = () => {
      if (!loopWidth) return 0;
      return loopWidth / speedSeconds;
    };

    const tick = (ts) => {
      if (!visible || paused || !run) {
        rafId = null;
        lastTs = 0;
        return;
      }

      if (!lastTs) lastTs = ts;
      const dt = Math.min((ts - lastTs) / 1000, 0.05);
      lastTs = ts;

      const delta = pxPerSecond() * dt;
      pos += dir === "right" ? -delta : delta;

      normalizePos();

      rafId = requestAnimationFrame(tick);
    };

    const start = () => {
      if (rafId || paused || !visible || !run) return;
      rafId = requestAnimationFrame(tick);
    };

    const stop = () => {
      if (!rafId) return;
      cancelAnimationFrame(rafId);
      rafId = null;
      lastTs = 0;
    };

    const setPaused = (val) => {
      paused = val;
      if (paused) stop();
      else start();
    };
    
    const easeInOutCubic = (t) =>
    t < 0.5
        ? 4 * t * t * t
        : 1 - Math.pow(-2 * t + 2, 3) / 2;

    let nudgeRaf = null;
    const cancelNudge = ({ resume = false } = {}) => {
    if (nudgeRaf) {
        cancelAnimationFrame(nudgeRaf);
        nudgeRaf = null;
    }

    lastTs = 0;

    if (resume) {
        paused = false;
        start();
    }
    };

    const animateNudge = (distance, duration = 580) => {
    if (nudgeRaf) {
        cancelAnimationFrame(nudgeRaf);
        nudgeRaf = null;
    }

    setPaused(true);

    const startPos = pos;
    const startTime = performance.now();

    const step = (now) => {
        const elapsed = now - startTime;
        const t = Math.min(elapsed / duration, 1);
        const eased = easeInOutCubic(t);

        pos = startPos + distance * eased;
        normalizePos();

        if (t < 1) {
        nudgeRaf = requestAnimationFrame(step);
        } else {
        nudgeRaf = null;
        lastTs = 0;
        setPaused(false);
        }
    };

    nudgeRaf = requestAnimationFrame(step);
    };

    const nudge = (direction) => {
        const amount = Math.round(viewport.clientWidth * 0.65);
        const distance = direction === "prev" ? -amount : amount;
        animateNudge(distance, 500);
    };


    prevBtn?.addEventListener("click", () => nudge("prev"));
    nextBtn?.addEventListener("click", () => nudge("next"));

    const io = new IntersectionObserver(
      (entries) => {
        visible = entries.some((e) => e.isIntersecting);
        if (visible) start();
        else stop();
      },
      { root: null, threshold: 0.05 }
    );

    io.observe(section);

    const ro = new ResizeObserver(() => {
      if (resizeRaf) cancelAnimationFrame(resizeRaf);

      resizeRaf = requestAnimationFrame(() => {
        resizeRaf = null;
        measure();
      });
    });

    ro.observe(section);
    ro.observe(inner);

    const imgs = inner.querySelectorAll("img");
    let pending = 0;

    imgs.forEach((img) => {
      if (!img.complete) {
        pending += 1;
        img.addEventListener(
          "load",
          () => {
            pending -= 1;
            if (pending <= 0) {
              const loopWidth = getLoopWidth();
              if (loopWidth && pos === 0) {
                pos = loopWidth;
              }
              measure();
              start();
            }
          },
          { once: true }
        );
      }
    });

    const initPosition = () => {
      measure();
    };

    const handleVisibilityChange = () => {
        if (document.hidden) {
            stop();
            cancelNudge({ resume: false });
        } else {
            if (!pos) pos = loopWidth || getLoopWidth();
            normalizePos();

            paused = false;
            cancelNudge({ resume: false });
            start();
        }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

        initPosition();
        start();

        section._logoMarqueeDestroy = () => {
        stop();
        cancelNudge({ resume: false });
        if (resizeRaf) cancelAnimationFrame(resizeRaf);
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        io.disconnect();
        ro.disconnect();
        };
    };

  const mountAll = () => {
    document.querySelectorAll(SELECTOR).forEach((section) => {
      if (section._logoMarqueeInited) return;
      section._logoMarqueeInited = true;
      initMarquee(section);
    });
  };

  mountAll();

  document.addEventListener("shopify:section:load", (e) => {
    e.target?.querySelectorAll?.(SELECTOR)?.forEach((section) => {
      if (section._logoMarqueeInited) return;
      section._logoMarqueeInited = true;
      initMarquee(section);
    });
  });

  document.addEventListener("shopify:section:unload", (e) => {
    e.target?.querySelectorAll?.(SELECTOR)?.forEach((section) => {
      section._logoMarqueeDestroy?.();
    });
  });
})();
